import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Icon} from "@material-ui/core";
import {CheckCircle} from "@material-ui/icons";


function rand() {
    return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
    const top = 50 + rand();
    const left = 50 + rand();

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: "50%",
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));


export default function ConfirmInfo(props) {
    const classes = useStyles();
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);


    return (
        <div align={"center"} style={{marginTop:"300px", marginLeft:"20px",marginRight:"20px"}}>
            <Icon color={"primary"}><CheckCircle style={{fontSize:"xxx-large"}}></CheckCircle></Icon>
            <h1>Thank you for your booking!</h1>
            <h5> Payment will be taken by 2PM AEDT on the next business day. At this time you will receive an email confirmation from one of our staff.</h5>
            <h5>If your booking departs within the next 48 Hours Please Quote #{props.text} to the ski hire shop staff.</h5>
        </div>
    );
}
